import { NAME } from './constants';

export const ARCHIVE_PROPOSAL = `${NAME}/ARCHIVE_PROPOSAL`;
export const ARCHIVE_PROPOSAL_FAILURE = `${NAME}/ARCHIVE_PROPOSAL_FAILURE`;
export const ARCHIVE_PROPOSAL_SUCCESS = `${NAME}/ARCHIVE_PROPOSAL_SUCCESS`;

export const DELETE_PROPOSAL = `${NAME}/DELETE_PROPOSAL`;
export const DELETE_PROPOSAL_FAILURE = `${NAME}/DELETE_PROPOSAL_FAILURE`;
export const DELETE_PROPOSAL_SUCCESS = `${NAME}/DELETE_PROPOSAL_SUCCESS`;

export const FETCH_PROPOSALS = `${NAME}/FETCH_PROPOSALS`;
export const FETCH_PROPOSALS_FAILURE = `${NAME}/FETCH_PROPOSALS_FAILURE`;
export const FETCH_PROPOSALS_SUCCESS = `${NAME}/FETCH_PROPOSALS_SUCCESS`;

export const OPEN_PROPOSAL_MODAL = `${NAME}/OPEN_PROPOSAL_MODAL`;

export const RESET = `${NAME}/RESET`;

export const SHOW_EMPTY_STATE = `${NAME}/SHOW_EMPTY_STATE`;
